import React from 'react';
import PropTypes from 'prop-types';

const DisplayPanel = ({ ensName, userAddress, userBalance, usdcBalance }) => {
	return (
		<div>
			<pre style={{ fontSize: '1.5em', marginRight: '30px' }}>
				{' '}
				<div style={{ margin: 'auto' }}>
					{' '}
					<span style={{ fontSize: '1.4em' }} role="img" aria-label="smile">
						{/* allowedEmoji[Math.floor(Math.random() * allowedEmoji.length)] */}
						🧙🏻‍♂️
					</span>{' '}
					{ensName == null ? userAddress : ensName}{' '}
					<div style={{ color: 'lightblue', display: 'inline' }}> Balance : </div> {userBalance} ETH ,{' '}
					{usdcBalance} USDC
				</div>
			</pre>
		</div>
	);
};

DisplayPanel.propTypes = {
	ensName: PropTypes.string,
	userAddress: PropTypes.string,
	userBalance: PropTypes.string,
	usdcBalance: PropTypes.string
};

export default DisplayPanel;
